import * as React from 'react';
import { render } from 'react-dom';
import { DeviceType, PageType, Vertical } from '../../shared/types/ast';
import { MarketContentWithConfig } from './market-content';

export function moveContentboard() {
    const threeColumns = window.matchMedia('(min-width: 768px)');

    if (threeColumns.matches) {
        const contentboard = document.getElementById('contentboard');
        if (contentboard) {
            const left = contentboard.parentElement;
            if (left) {
                const right = left.nextElementSibling;
                if (right) {
                    if (left.clientHeight * 1.38 > right.clientHeight) {
                        const grid = left.parentElement;
                        if (grid) {
                            const main = grid.parentElement;
                            if (main) {
                                const target = grid.nextSibling;
                                if (target) {
                                    main.insertBefore(contentboard, target);
                                } else {
                                    main.appendChild(contentboard);
                                }
                                return true;
                            }
                        }
                    }
                }
            }
        }
    }
    return false;
}

type MarketContentProps = {
    deviceType: DeviceType;
    vertical?: Vertical;
    pageType?: PageType;
};

export function renderMarketContent(
    id: string,
    props: MarketContentProps,
    callback?: () => void,
) {
    if (document) {
        const wide = moveContentboard();
        const container = document.getElementById(id);
        if (container) {
            container.classList.add('panel');
            render(
                <MarketContentWithConfig id={id} wide={wide} {...props} />,
                container,
                callback,
            );
        }
    }
}
